/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const e = (D, r, t) => {
  const o = typeof D == "string" ? parseInt(D) : D;
  if (!Number.isNaN(o))
    return o !== void 0 ? o : r ? t ? void 0 : -1 : 0;
};
export {
  e as getTabIndex
};
